import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { authService } from "../service";
import { validateSignupForm } from "../utils/validationSignUp";

export const useSignup = () => {
  const [params] = useSearchParams();
  const invitationToken = params.get("token");
  const invitedEmail = params.get("email");

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    gender: "homme",
    email: invitedEmail ||"",
    date_of_birth: "",
    phone: "",
    professional_address: "",
    profession: "",
    password: "",
    confirm_password: "",
    token: invitationToken || null,
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const [acceptedConditions, setAcceptedConditions] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setTouched((prev) => ({ ...prev, [name]: true }));

    const validationErrors = validateSignupForm({ ...formData, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: validationErrors[name] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!acceptedConditions) {
      toast.error("Veuillez accepter les conditions d'utilisation.");
      return;
    }

    const validationErrors = validateSignupForm(formData);
    console.log(formData);
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      return;
    }

    if (formData.password !== formData.confirm_password) {
      toast.error("Les mots de passe ne correspondent pas.");
      return;
    }

    const { confirm_password, ...payload } = formData;

    try {
      setLoading(true);
      console.log(payload);
      await authService.signup(payload);
      toast.success("Inscription réussie !");
      navigate("/login");
    } catch (err) {
      console.error(err.response?.data);
      toast.error(err.response?.data?.detail || "Erreur lors de l'inscription");
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    errors,
    touched,
    loading,
    acceptedConditions,
    setAcceptedConditions,
    handleChange,
    handleSubmit,
  };
};
